var exports = {
  "Lw": "VoiceRegionTeleportOverlay.module__overlay___NVhUWn",
  "t5": "VoiceRegionTeleportOverlay.module__voiceRegionTeleportFadeIn___NVhUWn",
  "Vs": "VoiceRegionTeleportOverlay.module__tile___NVhUWn",
  "Pf": "VoiceRegionTeleportOverlay.module__label___NVhUWn",
};

module.exports = exports;
